export default {
  SET_EXPENSE_LIST(state, expenseList) {
    state.expenseList = expenseList;
  },
};
